import { render, staticRenderFns } from "./PhdProposal.vue?vue&type=template&id=3d8b115d&"
import script from "./PhdProposal.vue?vue&type=script&lang=js&"
export * from "./PhdProposal.vue?vue&type=script&lang=js&"
import style0 from "./PhdProposal.vue?vue&type=style&index=0&id=3d8b115d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports